import type { MembershipRole } from '@repo/api-client/dtos';
import { useActiveOrganization } from '@repo/api-client/react';
import { useMemo } from 'react';

/**
 * Resolve the caller's role in the *active* organization, plus derived
 * booleans that mirror the server's `@Roles()` matrix.
 *
 * Port of `apps/mobile/hooks/useActiveRole.ts` — web sources role from
 * `useActiveOrganization()` (session org list item) instead of the
 * mobile workspace provider.
 */
export function useActiveRole() {
  const active = useActiveOrganization();
  return useMemo(() => {
    const role: MembershipRole | null = active?.role ?? null;
    const canEditOrg = role === 'owner' || role === 'admin';
    const canArchiveOrg = role === 'owner';
    const canManageTeam = canEditOrg;
    return { role, canEditOrg, canArchiveOrg, canManageTeam };
  }, [active]);
}
